import { parseISO } from "date-fns";
import { z } from "zod";

const BusinessDtoSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  modified_at: z.string(),
  name: z.string(),
  industry: z.string().nullable(),
  timezone: z.string(),
  currency: z.string(),
  owner_id: z.string().nullable(),
});

export const BusinessSchema = BusinessDtoSchema.transform((dto) => ({
  id: dto.id,
  createdAt: parseISO(dto.created_at),
  modifiedAt: parseISO(dto.modified_at),
  name: dto.name,
  industry: dto.industry,
  timezone: dto.timezone,
  currency: dto.currency,
  ownerId: dto.owner_id,
}));

export type BusinessDto = z.infer<typeof BusinessDtoSchema>;
export type Business = z.infer<typeof BusinessSchema>;

export function fromBusinessDto(dto: unknown): Business {
  return BusinessSchema.parse(dto);
}
